import $ from 'jquery';
import axios from 'axios';

export const contactUsFormFloatingLabels = () => {
    const formGroups = $('.form__group');

    const checkFormField = (field, label) => {
        const valueLength = $(field).val()?.length ?? 0;

        if ($(field).is(':focus')) {
            $(label).addClass('form__label--active');
            $(field).parent('.form__group').addClass('form__group--active');
            if ($(field).hasClass('form__input') && $(window).width() > 767) {
                $('.form__input').parent('.form__group').addClass('form__group--active');
            }
        } else if (valueLength > 0) {
            $(label).addClass('form__label--active');
            $(field).parent('.form__group').addClass('form__group--active');
            if ($(field).hasClass('form__input') && $(window).width() > 767) {
                $('.form__input').parent('.form__group').addClass('form__group--active');
            }
        } else {
            $(label).removeClass('form__label--active');
            if ($(field).hasClass('form__input') && $(window).width() > 767 && ($('.form__input').val()?.length ?? 0) <= 0) {
                $('.form__input').parent('.form__group').removeClass('form__group--active');
            }
            if ($(field).hasClass('form__textarea')) {
                $(field).parent('.form__group').removeClass('form__group--active');
            }
        }
    }

    $(formGroups).each(function(index, group) {
        const formLabel = $(group).find('.form__label');
        const formInput = $(group).find('.form__input');
        const formTextarea = $(group).find('.form__textarea');

        if (formInput.length) {
            checkFormField(formInput, formLabel);
            formInput.on('change input focusin focusout', function() {
                checkFormField(formInput, formLabel);
            });
        }

        if (formTextarea.length) {
            checkFormField(formTextarea, formLabel);
            formTextarea.on('change input focusin focusout', function() {
                checkFormField(formTextarea, formLabel);
            });
        }
    });
};

export const contactUsFormValidation = () => {
    const contactForm = document.querySelector('.form--contact');

    if (!contactForm) {
        return;
    }

    const msgs = contactForm.dataset;
    const msgRequired = msgs.msgNameRequired || 'This field is required';
    const msgMinlength = msgs.msgMinlength || 'This field must contain at least 3 characters';
    const msgEmail = msgs.msgEmail || 'Email address is not in valid format';
    const msgPrivacy = msgs.msgPrivacy || 'To submit a form, you need to agree with our Privacy Policy first.';

    $.validator.addMethod("customEmail",
        function(value, element) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
        },
        msgEmail
    );

    if (contactForm) {
        $(".form--contact").validate({
            rules: {
                'contact_us_form[nameContactUs]': {
                    required: true,
                    minlength: 3,
                },
                'contact_us_form[emailContactUs]': {
                    required: true,
                    customEmail: true,
                },
                'contact_us_form[interest]': {
                    required: true,
                    minlength: 3
                },
                'contact_us_form[privacyPolicyContactUs]': {
                    required: true,
                },
            },
            messages: {
                'contact_us_form[nameContactUs]': {
                    required: msgRequired,
                    minlength: msgMinlength,
                },
                'contact_us_form[emailContactUs]': {
                    required: msgRequired,
                    email: msgEmail,
                    customEmail: msgEmail,
                },
                'contact_us_form[interest]': {
                    required: msgRequired,
                    minlength: msgMinlength,
                },
                'contact_us_form[privacyPolicyContactUs]': {
                    required: msgPrivacy,
                },
            },
            errorElement: 'div',
            errorClass: 'form__error',
            errorPlacement: function(error, element) {
                error.appendTo(element.parent());
            },
            submitHandler: function(form, event) {
                if ($(form).valid()) {
                    contactUsFormSubmit(event);
                }
                return false;
            },
        }).settings.ignore = [];
    }
};

async function contactUsFormSubmit (event) {
    event.preventDefault();
    const formElement = $('.form--contact');
    let response;

    try {
        const locale = formElement[0].dataset.locale || 'en';
        const submitRoute = `/${locale}/contact-us/form`;
        const payload = new FormData(formElement[0]);
        response = await axios.post(submitRoute, payload);

        if ($(formElement).parents('.contact').length > 0) {
            if ($(response.data).filter('.form--contact').length) {
                $(formElement).parent().find('#recaptcha-scripts').replaceWith($(response.data).filter('#recaptcha-scripts'))
                $(formElement).find('#form-recaptcha').replaceWith($(response.data).find('#form-recaptcha'))
            } else {
                location.href = response.data.data.redirect_uri;
                $(formElement)[0].reset();
            }
        } else {
            $(formElement).html('<div class="form__message"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389955 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4441 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9971 6.61393 17.048 4.3264 15.3608 2.63919C13.6736 0.951987 11.3861 0.00285814 9 0V0ZM13.3956 7.5456L8.4456 12.4956C8.34113 12.6001 8.2171 12.683 8.08059 12.7395C7.94408 12.7961 7.79776 12.8252 7.65 12.8252C7.50224 12.8252 7.35592 12.7961 7.21941 12.7395C7.0829 12.683 6.95887 12.6001 6.8544 12.4956L4.6044 10.2456C4.3934 10.0346 4.27485 9.7484 4.27485 9.45C4.27485 9.15159 4.3934 8.8654 4.6044 8.6544C4.81541 8.44339 5.10159 8.32485 5.4 8.32485C5.69841 8.32485 5.98459 8.44339 6.1956 8.6544L7.65 10.1088L11.8044 5.9544C11.9089 5.84992 12.0329 5.76704 12.1694 5.7105C12.3059 5.65395 12.4522 5.62485 12.6 5.62485C12.7478 5.62485 12.8941 5.65395 13.0306 5.7105C13.1671 5.76704 13.2911 5.84992 13.3956 5.9544C13.5001 6.05888 13.583 6.18291 13.6395 6.31942C13.696 6.45593 13.7251 6.60224 13.7251 6.75C13.7251 6.89775 13.696 7.04406 13.6395 7.18057C13.583 7.31708 13.5001 7.44112 13.3956 7.5456Z" fill="#0C9B00"/></svg>' + response.data.message + '</div>');
        }        
    } catch (err) {
        const errorResponse = response?.data?.message ?? err.message;
        $(formElement).find('.js-form-error').empty().append(`<div class="form__message form__message--error">${errorResponse}</div>`);
        throw err;
    }
}
